import React from 'react'
import styles from './MoreEntries.module.css'
import truncate from '../../../utils/truncate'

const MoreEntries = ({
  coverImage,
  title,
  summary,
  slug
}) => {
  const goToPost = () => {
    window.location = `/blog/${slug}`
  }
  const ellipsisSummary = 140
  return (
    <div>
      <div
        onClick={goToPost}
        className={styles.Entry}
      >
        <img
          alt="cover post"
          className={styles.EntryImage}
          src={coverImage}
        />
        <div className={styles.EntryText}>
          <p className={styles.EntryTitle}>{title}</p>
          <p className={styles.EntrySummary}>{truncate(summary, ellipsisSummary)}</p>
        </div>
        <div className={styles.EntryActions}>
          <p>Leer más</p>
        </div>
      </div>
    </div>
  )
}

export default MoreEntries
